import React from 'react';
import Logo from 'url:../../../src/img/logo.png';
import styles from 'bundle-text:./styles.css';
import 'regenerator-runtime/runtime'

const Alert = ({ isOpen = false, onAccept = ()=>{ } }) => (
    <React.Fragment>
        <style>
            {styles}
        </style>
        <div className={`bg__alert ${isOpen ? 'active': ''}`}>
            <div className={`container__alert ${isOpen ? 'active': ''}`}>
                <div className="close" onClick={onAccept}>
                    <svg viewBox="0 0 512 512">
                        <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z" />
                    </svg>
                </div>
                <div className="header__alert">
                    <h1 className="title">Thank you!</h1>
                </div>
                <div className="body__alert">
                    <div className={`container__logo ${isOpen ? 'active': ''}`}>
                        <img className="img__logo" src={Logo} alt="SkyAlert USA" />
                    </div>
                    <p>We have received your information</p>
                    <p>We will respond as soon as possible.</p>
                </div>
                <div className="footer__alert">
                    <button className="btn btn__accept" onClick={onAccept}>
                        Accept
                    </button>
                </div>
            </div>
        </div>
    </React.Fragment >
)

export default Alert;